import React from "react";
import ComicBase from "../../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="MORNING Delight"
      portada="https://fullcomics18.org/img24/morning-delight-9.jpg"
   paginas={[
  "https://fullcomics18.org/img24/morning-delight-1.jpg",
  "https://fullcomics18.org/img24/morning-delight-2.jpg",
  "https://fullcomics18.org/img24/morning-delight-3.jpg",
  "https://fullcomics18.org/img24/morning-delight-4.jpg",
  "https://fullcomics18.org/img24/morning-delight-5.jpg",
  "https://fullcomics18.org/img24/morning-delight-6.jpg",
  "https://fullcomics18.org/img24/morning-delight-7.jpg",
  "https://fullcomics18.org/img24/morning-delight-8.jpg",
  "https://fullcomics18.org/img24/morning-delight-9.jpg",
  "https://fullcomics18.org/img24/morning-delight-10.jpg",
  "https://fullcomics18.org/img24/morning-delight-11.jpg",
  "https://fullcomics18.org/img24/morning-delight-12.jpg",
  "https://fullcomics18.org/img24/morning-delight-13.jpg",
  "https://fullcomics18.org/img24/morning-delight-14.jpg",
  "https://fullcomics18.org/img24/morning-delight-15.jpg",
  "https://fullcomics18.org/img24/morning-delight-16.jpg",
  "https://fullcomics18.org/img24/morning-delight-17.jpg",
  "https://fullcomics18.org/img24/morning-delight-18.jpg",
  "https://fullcomics18.org/img24/morning-delight-19.jpg",
  "https://fullcomics18.org/img24/morning-delight-20.jpg",
  "https://fullcomics18.org/img24/morning-delight-21.jpg",
  "https://fullcomics18.org/img24/morning-delight-22.jpg",
  "https://fullcomics18.org/img24/morning-delight-23.jpg",
  "https://fullcomics18.org/img24/morning-delight-24.jpg",
  "https://fullcomics18.org/img24/morning-delight-25.jpg",
  "https://fullcomics18.org/img24/morning-delight-26.jpg",
  "https://fullcomics18.org/img24/morning-delight-27.jpg",
  "https://fullcomics18.org/img24/morning-delight-28.jpg",
  "https://fullcomics18.org/img24/morning-delight-29.jpg",
  "https://fullcomics18.org/img24/morning-delight-30.jpg",
  "https://fullcomics18.org/img24/morning-delight-31.jpg",
  "https://fullcomics18.org/img24/morning-delight-32.jpg",
  "https://fullcomics18.org/img24/morning-delight-33.jpg",
  "https://fullcomics18.org/img24/morning-delight-34.jpg",
  "https://fullcomics18.org/img24/morning-delight-35.jpg",
  "https://fullcomics18.org/img24/morning-delight-36.jpg",
  "https://fullcomics18.org/img24/morning-delight-37.jpg",
  "https://fullcomics18.org/img24/morning-delight-38.jpg",
  "https://fullcomics18.org/img24/morning-delight-39.jpg",
  "https://fullcomics18.org/img24/morning-delight-40.jpg",
  "https://fullcomics18.org/img24/morning-delight-41.jpg",
  "https://fullcomics18.org/img24/morning-delight-42.jpg",
  "https://fullcomics18.org/img24/morning-delight-43.jpg",
  "https://fullcomics18.org/img24/morning-delight-44.jpg",
  "https://fullcomics18.org/img24/morning-delight-45.jpg",
  "https://fullcomics18.org/img24/morning-delight-46.jpg",
  "https://fullcomics18.org/img24/morning-delight-47.jpg",
  "https://fullcomics18.org/img24/morning-delight-48.jpg",
  "https://fullcomics18.org/img24/morning-delight-49.jpg",
  "https://fullcomics18.org/img24/morning-delight-50.jpg",
  "https://fullcomics18.org/img24/morning-delight-51.jpg",
  "https://fullcomics18.org/img24/morning-delight-52.jpg",
  "https://fullcomics18.org/img24/morning-delight-53.jpg",
  "https://fullcomics18.org/img24/morning-delight-54.jpg",
  "https://fullcomics18.org/img24/morning-delight-55.jpg",
  "https://fullcomics18.org/img24/morning-delight-56.jpg",
  "https://fullcomics18.org/img24/morning-delight-57.jpg",
  "https://fullcomics18.org/img24/morning-delight-58.jpg",
  "https://fullcomics18.org/img24/morning-delight-59.jpg",
  "https://fullcomics18.org/img24/morning-delight-60.jpg",
  "https://fullcomics18.org/img24/morning-delight-61.jpg",
  "https://fullcomics18.org/img24/morning-delight-62.jpg",
  "https://fullcomics18.org/img24/morning-delight-63.jpg",
  "https://fullcomics18.org/img24/morning-delight-64.jpg",
  "https://fullcomics18.org/img24/morning-delight-65.jpg",
  "https://fullcomics18.org/img24/morning-delight-66.jpg",
  "https://fullcomics18.org/img24/morning-delight-67.jpg",
  "https://fullcomics18.org/img24/morning-delight-68.jpg",
  "https://fullcomics18.org/img24/morning-delight-69.jpg",
  "https://fullcomics18.org/img24/morning-delight-70.jpg",
  "https://fullcomics18.org/img24/morning-delight-71.jpg",
  "https://fullcomics18.org/img24/morning-delight-72.jpg",
  "https://fullcomics18.org/img24/morning-delight-73.jpg",
  "https://fullcomics18.org/img24/morning-delight-74.jpg",
  "https://fullcomics18.org/img24/morning-delight-75.jpg",
  "https://fullcomics18.org/img24/morning-delight-76.jpg",
  "https://fullcomics18.org/img24/morning-delight-77.jpg",
  "https://fullcomics18.org/img24/morning-delight-78.jpg",
  "https://fullcomics18.org/img24/morning-delight-79.jpg",
  "https://fullcomics18.org/img24/morning-delight-80.jpg"
]}
      sugeridos={[]}


      info={{
         grupo: "Manga",
    tipo: "Comic 3D",
    idioma: "Español",
    serie: "Street Fighter",
    personajes: ["Chun Li"],
etiquetas: ["3D", "Chun Li", "Street Fighter", "Video Juegos", "Big Ass","BBW"],
    artistas: "PervertMuffinMajima",
      }}
    />
  );
}

export const infoManga = {
  titulo: "MORNING Delight",
  portada: "https://fullcomics18.org/img24/morning-delight-9.jpg",
  reverso: "https://fullcomics18.org/img24/morning-delight-22.jpg",
   fecha:"2026-05-17",


  info: {
    grupo: "Manga",
    tipo: "Comic 3D",
    idioma: "Español",
    serie: "Street Fighter",
    personajes: ["Chun Li"],
etiquetas: ["3D", "Chun Li", "Street Fighter", "Video Juegos", "Big Ass","BBW"],
    artistas: "PervertMuffinMajima",
  },
};
